<template>
  <div class="subject-detail-box">
    <!-- 标题图 -->
    <div class="header">
      <img :src="subject.titleImg" />
    </div>

    <!-- 香蕉图 -->
    <van-swipe ref="subjectSwipe" v-if="subject.allSlideImages" class="carousel"  indicator-color="white" :loop="false" id="subjectSwipe">
      <!-- 介绍视频封面图,点击播放视频 -->
      <van-swipe-item class="subject-cover" v-if="subject.videoDesc" >
        <video
          id="video"
          class="video_content"
          :src="subject.videoDesc"
          controls ="true"
          :poster="subject.videoDescCover"
          preload="auto"
          webkit-playsinline="true"
          playsinline="true"
          x-webkit-airplay="allow"
          x5-video-player-type="h5"
          x5-video-player-fullscreen="true"
          x5-video-orientation="portraint"
          style="object-fit:fill">
        </video>
      </van-swipe-item>

      <van-swipe-item v-for="(slideImg, index) in subject.allSlideImages" :key="index">
        <van-image :src="slideImg" />
      </van-swipe-item>
    </van-swipe>

    <!-- 课程描述 -->
    <div class="description">{{ subject.desc }}</div>

    <!-- 课程信息 -->
    <div class="infomation">
      <div class="body" :class="subject.myCoupon ? 'active' : ''">
        <div class="bd">
          <span class="price" v-if="subject.isGroup">￥{{ subject.myCoupon ? subject.myCoupon.coupon.groupPrice : subject.groupPrice }}</span>
          <span class="price" v-else>¥{{subject.fullPrice}}</span>
        </div>
        <div class="bodyPrice" v-if="subject.isGroup">
          <p class="oprice">原价: ￥{{subject.fullPrice}}</p>
          <p class="opriceText"><span>{{subject.myCoupon ? '券后价' : '团购价'}}</span></p>
        </div>
        <div class="bodyPrice" v-else>
          <p class="oprice"></p>
        </div>
        <div class="count-down" v-if="subject.myCoupon">
          <p>距优惠券结束</p>
          <van-count-down :time="countDown()" >
            <template v-slot="timeData">
              <span v-if="timeData.days > 0">{{ timeData.days }}天</span>
              <span>{{timeData.hours > 9 ? '' : 0}}{{ timeData.hours }}:</span>
              <span>{{timeData.minutes > 9 ? '' : 0}}{{ timeData.minutes }}:</span>
              <span>{{timeData.seconds > 9 ? '' : 0}}{{ timeData.seconds }}</span>
            </template>
          </van-count-down>
        </div>
      </div>
      <div class="footer">
        <div class="item" v-if="subject.ageGroup">
          <van-icon name="checked" color="#3288fa" />
          适合 {{ subject.ageGroup }} 岁
        </div>
        <div class="item" v-if="subject.itemNum">
          <van-icon name="checked" color="#3288fa" />
          {{ subject.itemNum }} 节课
        </div>
        <div class="item">
          <van-icon name="checked" color="#3288fa" />
          永久回看
        </div>
        <div class="item" @click="subject.isGroup ? null : showTip = !showTip">
          <van-icon name="checked" color="#3288fa" />
          {{ subject.isGroup ? '人数不足退款' : '服务说明' }}
        </div>
      </div>
      <div class="ft" v-if="subject.isGroup && subject.pinkSalesNum > 0">
        <div class="participate_img" v-for="(user, index) in subject.pinkUsers" :key="index">
          <img :src="user.avatar" v-if="index < 3" />
        </div>
        <div class="participate_num_text" v-if="subject.pinkSalesNum > 0">
          <span>等</span><span class="people_num">{{ subject.pinkSalesNum }}</span><span>人已拼团成功</span>
        </div>
        <div @click="showTip = !showTip">
          <div class="pink_rule">拼团规则</div>
        </div>
      </div>
    </div>

    <!-- 服务说明 -->
    <van-action-sheet v-model="showTip" title="服务说明" class="tips-box">
      <ul class="tips">
        <li class="tip">
          <div class="title">
            <img :src="require('@/assets/icons/checked.png')" />
            <span class="explain_item_text">关于成团</span>
          </div>
          <div class="content">拼团时间为 {{ subject.pinkMinute ? (subject.pinkMinute / 60) : '48' }}小时，拼团期间未满足拼团人数即为拼团失败，已支付的费用将自动原路退回。</div>
        </li>

        <!-- <li class="tip">
          <div class="title">
            <img :src="require('@/assets/icons/checked.png')" />
            <span class="explain_item_text">关于上课</span>
          </div>
          <div class="content">课程每周四、六各解锁1集，解锁后您可以随意安排时间观看</div>
        </li> -->

        <li class="tip">
          <div class="title">
            <img :src="require('@/assets/icons/checked.png')" />
            <span class="explain_item_text">关于退费</span>
          </div>
          <div class="content">因课程为虚拟原创内容服务，拼团成功或单购成功后无法退款，请您确认无误后购买。</div>
        </li>

        <li class="tip">
          <div class="title">
            <img :src="require('@/assets/icons/checked.png')" />
            <span class="explain_item_text">关于有效期</span>
          </div>
          <div class="content">本课程一旦单购成功或拼团成功，课程解锁后，可以不限次数、永久回看。</div>
        </li>

        <li class="tip">
          <div class="title">
            <img :src="require('@/assets/icons/checked.png')" />
            <span class="explain_item_text">关于解释权</span>
          </div>
          <div class="content">明明城堡对本课程拥有最终法律解释权。</div>
        </li>
      </ul>
      <div class="btns">
        <div class="close" @click="showTip = false">我知道啦</div>
      </div>
    </van-action-sheet>

    <div class="line10"></div>

    <!-- 粘性导航 -->
    <van-sticky>
      <div class="tabs">
        <div class="tab" :class="{ 'active': active === 0 }" @click="toAnchor('#tabContent0', 0)">课程详情</div>
        <div class="tab" :class="{ 'active': active === 1 }" @click="toAnchor('#tabContent1', 1)">课程目录</div>
        <div class="tab" :class="{ 'active': active === 2 }" @click="toAnchor('#tabContent2', 2)">课程须知</div>
      </div>
    </van-sticky>

    <div class="tab-contents">
      <div class="tab-content" id="tabContent0">
        <div v-html="subject.content"></div>
      </div>
      <div class="tab-content" id="tabContent1">
        <div v-html="subject.indexContent"></div>
        <!-- 评论 -->
      </div>
      <div class="tab-content" id="tabContent2">
        <div v-html="subject.noticeContent"></div>
      </div>
    </div>

    <!-- 页脚 -->
    <!-- <div class="footer-box">
      <img src="@/assets/icons/copyright.png" alt="">
    </div> -->

    <!-- 返回顶部 -->
    <div class="anchor-box" @click="goTopAnchor">
      <img :src="require('@/assets/icons/top.png')" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubjectDetail',
  props: ['subject'],
  data() {
    return {
      active: 0,
      showTip: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.pageScroll)
  },
  methods: {
    countDown() {
      let now = new Date()
      let endDate = new Date(this.subject.myCoupon.endAt)
      return endDate - now
    },
    pageScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      let tabContent0 = this.$el.querySelector('#tabContent0').offsetTop - 50
      let tabContent1 = this.$el.querySelector('#tabContent1').offsetTop - 50
      let tabContent2 = this.$el.querySelector('#tabContent2').offsetTop - 50
      if (scrollTop > tabContent0 && scrollTop < tabContent1) {
        this.active = 0
      }
      if (scrollTop > tabContent1 && scrollTop < tabContent2) {
        this.active = 1
      }
      if (scrollTop > tabContent2) {
        this.active = 2
      }
    },
    goTopAnchor() {
      scroll(0, 0)
      this.active = 0
    },
    toAnchor(selector, index) {
      const anchor = this.$el.querySelector(selector)
      scroll(0, anchor.offsetTop)
      this.active = index

      // this.$zhuge.track('课程详情切换索引', {
      //   '索引': index
      // })
    }
  }
}
</script>

<style lang="scss">
.subject-detail-box {
  .header {
    img {
      width: 100%;
    }
  }

  // 香蕉图
  .carousel {
    width: 100vw;
    height: 210px;
    .subject-cover {
      width: 100vw;
      height: 100%;
    }
    img {
      width: 100vw;
      height: 210px;
    }
    .video_content {
      width: 100vw;
      height: 100%;
    }
    .van-swipe-item {
      .van-image {
        height: 100%;
      }
      .playbtn {
        z-index: 10247;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        width: 54px;
        height: 54px;
        background:  rgba(43,51,63,.7);
        border: 3px solid #fff;
        border-radius: 100%;
        &:after {
          content: '';
          width: 0;
          height: 0;
          border-top: 12px solid transparent;
          border-bottom: 12px solid transparent;
          border-left: 20px solid #fff;
          position: absolute;
          top: 15px;
          left: 20px;
        }
      }
      img {
        width: 100%;
      }
    }
  }

  .description {
    font-size: 14px;
    line-height: 19px;
    color: rgb(129, 44, 44);
    padding: 10px;
    font-weight: bold;
  }

  .infomation {
    background: #fff;
    .body {
      padding: 10px 0 10px 15px;
      display: flex;
      align-items: center;
      height: 43px;
      background-color: #ff7639;
      &.active{
        background: url('~@/assets/images/winterVacation_corss_bar.png') no-repeat center / 100%;
        background-size: cover;
      }
      .bd {
        color: #fff;
        font-size: 13px;
        .price{
          font-size: 23px;
          color: #fff;
          font-weight: bold;
        }
      }
      .bodyPrice {
        padding-left: 10px;
        align-items: center;
        flex: 1;
        .oprice{
          font-size: 13px;
          color: #fff;
          text-decoration: line-through
        }
        .opriceText {
          font-size: 10px;
          color: #fa512d;
          font-weight: blod;
          margin-top: 5px;
          span {
            padding: 4px;
            background-color: #ffffff;
            display: inline;
            font-weight: 700;
            line-height: 1;
            color: red;
            text-align: center;
            white-space: nowrap;
            vertical-align: baseline;
            border-radius: 5px;
          }
        }
      }
      .count-down{
        width: 130px;
        text-align: center;
        color: #ff7f2b;
        font-size: 16px;
        font-weight: bold;
        line-height: 30px;
        .van-count-down{
          text-align: center;
          color: #ff7f2b;
        }
      }
    }
    .footer {
      position: relative;
      display: flex;
      align-items: center;
      padding: 10px 15px;
      &:before{
        position: absolute;
        box-sizing: border-box;
        content: ' ';
        pointer-events: none;
        right: 0;
        top: 0;
        left: 15px;
        border-top: 1px solid #f5f5f5;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
      }
      .item {
        .van-icon {
          font-size: 4.3vw;
        }
        display: flex;
        color: #666;
        font-size: 3.3vw;
        margin-left: 7px;
        &:first-child{
          margin-left: 0;
        }
      }
    }
    .ft {
      flex: 1;
      height: 43px;
      display: flex;
      align-items: center;
      padding: 10px 15px;
      .participate_img {
        margin-right: -10px;
        overflow: hidden;
        img {
          border-radius: 50%;
          width: 32px;
          height: 32px;
        }
      }
      .participate_num_text {
        flex: 1;
        color: #666;
        margin-left: 26px;
        .people_num {
          color: #fa592d;
          padding: 0 2px;
        }
      }
      .pink_rule {
        color: #fa592d;
        font-size: 15px;
      }
    }
  }

  .tips-box {
    .tips {
      padding: 15px 15px 0;
      .tip {
        padding-bottom: 10px;
        &:not(:last-child) {
          margin-bottom: 10px;
          border-bottom: 1px solid #f5f5f5;
        }
        .title {
          margin-bottom: 5px;
          color: #333;
          font-size: 18px;
          font-weight: bold;
          img {
            display: inline-block;
            width: 18px;
            margin-right: 7px;
          }
          span {
            font-weight: bold;
          }
        }
        .content {
          font-size: 14px;
          line-height: 17px;
          padding-left: 25px;
          color: #999;
          letter-spacing: 1px;
        }
      }
    }
    .btns {
      .close {
        width: 92%;
        height: 40px;
        line-height: 40px;
        border-radius: 20px;
        background-color: #ff7404;
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        margin: 5px auto;
        z-index: 10245;
      }
    }
  }

  .line10 {
    background: #e6e6e6;
    height: 10px;
  }

  .tabs {
    display: flex;
    .tab{
      flex: 1;
      height: 44px;
      box-sizing: border-box;
      font-size: 17px;
      font-weight: bold;
      color: #666;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      img{
        width: 12px;
        height: 15px;
        margin-right: 5px;
      }
      &.active{
        color: #ff5825;
      }
    }
  }

  // 课程详情
  .tab-contents {
    padding: 1px 10px;
    background: #fff;
    .tab-content {
      width: 100%;
      img {
        width: 100%;
      }
      .messageImgBox{
        position: relative;
        .message_item_box{
          position: absolute;
          left: 0;
          top: 0;
          min-width: 300rpx;
          padding: 70px 37.5px 45px;
          .message_title_img{
            width: 242.5px;
            height: auto;
            position: absolute;
            left: 0;
            right: 0;
            top: 5px;
            margin: 0 auto;
          }
          .message_item{
            display: flex;
            padding: 10px 0 20px;
            border-bottom: 1px solid #be8224;
            .message_user_img{
              width: 40px;
              height: 40px;
              border-radius: 20px;
              overflow: hidden;
              margin-right: 16px;
            }
            .message_text{
              flex: 1;
              font-size: 13px;
              .message_title{
                color: #474747;

                margin-bottom: 8px;
              }
              .message_desc{
                color: #642408;
              }
            }
          }
        }
      }
    }
  }

  .footer-box {
    margin: 55px auto 0;
    padding-bottom: 67.5px;
    width: 191.5px;
    height: 80px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .anchor-box {
    width: 48px;
    height: 48px;
    position: fixed;
    right: 1%;
    top: 74%;
    z-index: 999;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
